import axios from 'axios';
import productCacheService from '../components/IndexDB/productCacheService';
import clearCompanyScopedCache from './companyCache';

// Single implementation of "switch active branch" used by every branch
// switcher in the UI. Switching branches must never leave the previous
// branch's cached products/customers/cart — or any other company-scoped
// cache (Dukakit Payments status, setup milestones, dismissed suggestions,
// Business Intelligence) — visible after the switch. See BranchManagerModal.vue
// and BottomMenu.vue, the two entry points.
export default {
  async switchTo(store, companyId) {
    await axios.get('/api/switch-branch', { params: { companyId } });

    // Backend has already flipped the active branch for this session, so
    // this refetch pulls the NEW branch's catalog before we reload.
    await productCacheService.hotReloadLocalDB();

    store.commit('resetStore');
    store.commit('removeUserDetails');
    clearCompanyScopedCache();

    window.location.reload();
  },
};
